import {Icon, ListItemText} from '@mui/material';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import AppBadge from 'main/core/AppBadge';
import AppIcon from 'main/core/AppLayout/components/AppIcon';
import AppNavLink from 'main/core/AppNavLink';
import {useAuthUser} from 'main/utility/AuthHooks';
import {checkPermission} from 'main/utility/helper/RouteHelper';
import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import {BUSINESS_ROLE} from 'shared/constants/AppConst';
import VerticalNavItem from './VerticalNavItem';

const VerticalItem = ({level, item}) => {
  const {user} = useAuthUser();
  const hasPermission = useMemo(
    () => checkPermission(item.permittedrole, user.role),
    [item.permittedrole, user.role],
  );
  if (!hasPermission) {
    return null;
  }

  return (
    <VerticalNavItem
      level={level}
      button
      component={AppNavLink}
      to={item.path}
      activeClassName='active'
      exact={item.exact}
    >
      {item.icon && (
        <Box component='span'>
          <Icon
            sx={{
              fontSize: 18,
              display: 'block',
              mr: 4,
            }}
            className={clsx('nav-item-icon', 'material-icons-outlined')}
            color='action'
          >
            <AppIcon name={item.icon} />
          </Icon>
        </Box>
      )}
      <ListItemText
        className='nav-item-content'
        primary={item.title}
        classes={{primary: 'nav-item-text'}}
      />
      {item.count && (
        <Box sx={{mr: 3.5}} className='menu-badge'>
          <AppBadge count={item.count} color={item.color} />
        </Box>
      )}
    </VerticalNavItem>
  );
};

VerticalItem.propTypes = {
  item: PropTypes.shape({
    layoutid: PropTypes.string.isRequired,
    title: PropTypes.string,
    menutype: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    permittedrole: PropTypes.oneOf(Object.values(BUSINESS_ROLE)),
    exact: PropTypes.bool,
    count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    color: PropTypes.string,
  }),
  level: PropTypes.number,
};

export default React.memo(VerticalItem);
